import axios from 'axios';
import qs from 'qs'
import storage from '../store/storage'
import Swal from 'sweetalert2';
import i18next from 'i18next';
import i18n from '../i18n';
//axios.defaults.baseURL = 'http://localhost:8082'
let ax = axios.create({
  baseURL: '/api',
  //baseURL:'http://192.168.9.47:8082',
  withCredentials: true, // 跨域携带证书
  timeout: 30000,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": 'Content-Type, Content-Length, Authorization, Accept, X-Requested-With',
  }
})

// add Authorization header
ax.interceptors.request.use(config => {
  //增加auth头
  let token = localStorage.getItem('token') || '';
  let lng = localStorage.getItem('i18nextLng') || '';
  config.headers.Authorization = `Bearer ${token}`;
  config.headers.common['Accept-Language'] = lng;
  return config
}, error => {
  console.error(error);
  Promise.reject(error);
});

//攔截器,add Refresh Token

// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []
ax.interceptors.response.use(function (response) {
  const res = response.data;
  if (res.return_code === 10003) {
    const config = response.config
    if (!isRefreshing) {
      isRefreshing = true
      let refresh_token = storage.get('refresh_token');
      return ax.post(`/WebApp/Login/RefreshToken?refresh_token=${refresh_token}`)
        .then(res => {
          // 1) put token to LocalStorage
          const { token, refresh_token } = res.data;
          storage.set("token", token);
          storage.set("refresh_token", refresh_token)
          // 2) Change Authorization header
          config.headers.Authorization = `Bearer ${token}`;
          // 3) return originalRequest object with Axios.
          requests.forEach(cb => cb(token));
          requests = []
          return ax(config);

        }).catch(res => {
          console.error('refreshtoken error =>', res)
          storage.loginout(); //后期记得在这里清空登录信息，跳转到登录，记得根据登录端口跳转到对应页面
        }).finally(() => {
          isRefreshing = false
        })

    }
    else {
      //正在刷新token，将返回一个未执行resolve的promise
      return new Promise((resolve) => {
        // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
        requests.push((token) => {
          // config.baseURL = ''
          config.headers.Authorization = `Bearer ${token}`;
          resolve(ax(config))
        })
      })
    }
  }
  //user's refresh-token expired  or Permission Denied
  if (res.return_code === 10012 || res.return_code === 10013) {
    console.info("user's refresh-token expired  or Permission Denied" + res);
    storage.loginout();
  }
  return response;
}, function (error) {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.msg = '错误请求'
        error.enmsg = 'Bad request'
        break
      case 401:
        error.msg = '未授权，请重新登录'
        error.enmsg = 'Unauthorized, please login again'
        break
      case 403:
        error.msg = '拒绝访问'
        error.enmsg = 'Access denied'
        break
      case 404:
        error.msg = '请求错误,未找到该资源'
        error.enmsg = 'Request error, resource not found'
        break
      case 405:
        error.msg = '请求方法未允许'
        error.enmsg = 'The requested method is not allowed'
        break
      case 408:
        error.msg = '请求超时'
        error.enmsg = 'Request Timeout'
        break
      case 500:
        error.msg = '服务器端出错'
        error.enmsg = 'Internal Server Error'
        break
      case 501:
        error.msg = '网络未实现'
        error.enmsg = 'Network not implemented'
        break
      case 502:
        error.msg = '网络错误'
        error.enmsg = 'Bad Gateway'
        break
      case 503:
        error.msg = '服务不可用'
        error.enmsg = 'Service Unavailable'
        break
      case 504:
        error.msg = '网络超时'
        error.enmsg = 'Gateway Timeout'
        break
      case 505:
        error.msg = 'http版本不支持该请求'
        error.enmsg = 'HTTP Version Not Supported'
        break
      default:
        error.msg = `连接错误${error.response.status}`
        error.enmsg = `Connection error${error.response.status}`
    }
    let errData = {
      code: error.response.status,
      msg: error.msg,
      enmsg: error.enmsg
    }
    Swal.fire({
      icon: 'error',
      title: i18next.language === "en-US" ? errData.enmsg : errData.msg,
      confirmButtonText: i18n.t('LoginPage.Swal.btn_ok'),
      allowOutsideClick: false
      //timer: 2000,
    })
    // 统一错误处理可以放这，例如页面提示错误...
    console.log('统一错误处理: ', errData)
  }
  return Promise.reject(error);
})

const itr = (type, url, params) => {
  if (typeof params !== 'object') {
    params = {}
  }
  let arg = qs.stringify(params)
  if (Object.keys(params).length > 0) {
    url = (type === 'get') ? url + '?' + arg : url
  }

  return ax[type](url, params)
}
const base = (type, url, params, loadingFlag, loadingText) => {
  if (loadingFlag) {

  }
  return new Promise((resolve, reject) => {
    itr(type, url, params)
      .then(response => {
        if (loadingFlag) {

        }
        resolve(response.data)
      })
      .catch(error => {
        if (loadingFlag) {

        }

        reject(error.data)
      })
  })
}

export const FormDataFormat = (url, type, FormDataObj, fn, loadingFlag) => {
  if (loadingFlag) { } else { }
  axios({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: type,
    url: url,
    data: FormDataObj
  }).then(response => {
    fn(response)
  })
}
export const Get = (url, params, loadingFlag, loadingText) => {
  return base('get', url, params, loadingFlag, loadingText)
}
export const Post = (url, params, loadingFlag, loadingText) => {
  return base('post', url, params, loadingFlag, loadingText)
}
// 是因为 post 和 put 第二个参数是data，所以可以直接在第二个参数的位置写上数据，后台可以访问到,而delete第二个参数是 config ，所以要通过 config 里面的 data 来传参，所以应该这样写：axios.delete('/api',{data:{id:1}})
export const Delete = (url, params, loadingFlag, loadingText) => {
  return base('delete', url, { data: params }, loadingFlag, loadingText)
}
export const Put = (url, params, loadingFlag, loadingText) => {
  return base('put', url, params, loadingFlag, loadingText)
}
export const Patch = (url, params, loadingFlag, loadingText) => {
  return base('patch', url, loadingFlag, loadingText)
}
export const Options = (url, params, loadingFlag, loadingText) => {
  return base('options', url, params, loadingFlag, loadingText)
}
